// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TestingSliderCatalog_wrapper__Bva1H"};